(function () {
  Flint.file("views/footer.js", function (require) {
    Flint.staticStyles("Footer", {
      "$": "#_flintapp .ViewFooter",
      "$mobileMode": "#_flintapp mobileMode.Footer, #_flintapp .Footer.mobileMode, #_flintapp .ViewFooter.mobileMode, #_flintapp .Footer > .mobileMode",
      "$copyright": "#_flintapp copyright.Footer, #_flintapp .Footer.copyright, #_flintapp .ViewFooter.copyright, #_flintapp .Footer > .copyright",
      "$mobileLogo": "#_flintapp mobileLogo.Footer, #_flintapp .Footer.mobileLogo, #_flintapp .ViewFooter.mobileLogo, #_flintapp .Footer > .mobileLogo",
      "$mobileRow": "#_flintapp mobileRow.Footer, #_flintapp .Footer.mobileRow, #_flintapp .ViewFooter.mobileRow, #_flintapp .Footer > .mobileRow",
      "$mobileLink": "#_flintapp mobileLink.Footer, #_flintapp .Footer.mobileLink, #_flintapp .ViewFooter.mobileLink, #_flintapp .Footer > .mobileLink",
      "$cols": "#_flintapp cols.Footer, #_flintapp .Footer.cols, #_flintapp .ViewFooter.cols, #_flintapp .Footer > .cols",
      "$colu": "#_flintapp colu.Footer, #_flintapp .Footer.colu, #_flintapp .ViewFooter.colu, #_flintapp .Footer > .colu",
      "$NavLink": "#_flintapp .ViewFooter .ViewNavLink",
      "$bigText": "#_flintapp bigText.Footer, #_flintapp .Footer.bigText, #_flintapp .ViewFooter.bigText, #_flintapp .Footer > .bigText",
      "$heading": "#_flintapp heading.Footer, #_flintapp .Footer.heading, #_flintapp .ViewFooter.heading, #_flintapp .Footer > .heading",
      "$logoColu": "#_flintapp logoColu.Footer, #_flintapp .Footer.logoColu, #_flintapp .ViewFooter.logoColu, #_flintapp .Footer > .logoColu",
      "$logo": "#_flintapp logo.Footer, #_flintapp .Footer.logo, #_flintapp .ViewFooter.logo, #_flintapp .Footer > .logo",
      "$lastColu": "#_flintapp lastColu.Footer, #_flintapp .Footer.lastColu, #_flintapp .ViewFooter.lastColu, #_flintapp .Footer > .lastColu"
    }, {
      "$": {
        alignItems: 'center',
        marginBottom: 30
      },
      "$mobileMode": {
        alignItems: 'center'
      },
      "$copyright": {
        marginTop: 8,
        color: '#999',

        alignSelf: 'center',
        textAlign: 'center'
      },
      "$mobileLogo": {
        width: 240,
        marginTop: 40
      },
      "$mobileRow": {
        marginTop: 14,
        flexDirection: 'row'
      },
      "$mobileLink": {
        margin: [0, 10],
        display: 'inline-block'
      },
      "$cols": {
        flexDirection: 'row',
        alignItems: 'stretch'
      },
      "$colu": {
        flexGrow: 1
      },
      "$NavLink": {
        marginBottom: 6
      },
      "$bigText": {
        color: '#999',

        textTransform: 'uppercase',
        fontStyle: 'italic',
        marginBottom: 6
      },
      "$heading": {
        marginBottom: 8
      },
      "$logoColu": {
        alignItems: 'center'
      },
      "$logo": {
        minHeight: 0
      },
      "$lastColu": {
        marginRight: 0
      }
    });
    Flint.view("Footer", function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });view.render(function () {
        return Flint.iff(context.isMobile.get()) && view.el(
          ["mobileMode", 1],
          { if: context.isMobile.get() },
          view.el(
            ["NavLink", 1],
            { to: "/", track: "footerLogo" },
            view.el(["img", 1], { className: "mobileLogo", src: "/images/pr-logo-small.png" })
          ),
          view.el(
            ["mobileRow", 1],
            null,
            view.el(
              ["NavLink", 2],
              { className: "mobileLink", to: "/about" },
              "About"
            ),
            view.el(
              ["NavLink", 3],
              { className: "mobileLink", to: "/contact" },
              "Contact"
            ),
            view.el(
              ["NavLink", 4],
              { className: "mobileLink", to: "/terms" },
              "Privacy & Terms"
            )
          ),
          view.el(
            ["copyright", 1],
            null,
            "© 2016 Positive Relating, Inc"
          )
        );
      });view.render(function () {
        return Flint.iff(!context.isMobile.get()) && view.el(
          ["desktopMode", 1],
          { if: !context.isMobile.get() },
          view.el(
            ["cols", 1],
            null,
            view.el(
              ["colu", 1],
              { className: "logoColu" },
              view.el(
                ["NavLink", 5],
                { to: "/" },
                view.el(["img", 2], { className: "logo", src: "/images/pr-logo-compact-small.png" })
              ),
              view.el(
                ["copyright", 2],
                null,
                "© 2016 Positive Relating, Inc"
              )
            ),
            view.el(
              ["colu", 2],
              { className: "prLinks" },
              view.el(
                ["bigText", 1],
                { className: "heading" },
                "Home"
              ),
              view.el(
                ["NavLink", 6],
                { to: "/about" },
                "About"
              ),
              view.el(
                ["NavLink", 7],
                { to: "/contact" },
                "Contact"
              ),
              view.el(
                ["NavLink", 8],
                { to: "/terms" },
                "Privacy & Terms"
              )
            ),
            view.el(
              ["colu", 3],
              null,
              view.el(
                ["bigText", 2],
                { className: "heading" },
                "Shows"
              ),
              view.el(
                ["NavLink", 9],
                { to: "http://thegirlsgame.tv" },
                "The Girl's Game"
              )
            ),
            view.el(
              ["colu", 4],
              null,
              view.el(
                ["bigText", 3],
                { className: "heading" },
                "Products"
              ),
              view.el(
                ["NavLink", 10],
                { to: "https://mrright.net" },
                "Mr. Right"
              ),
              view.el(
                ["NavLink", 11],
                { to: "/3sa" },
                "3 Second Attraction"
              ),
              view.el(
                ["NavLink", 12],
                { to: "/enchant-mr-right" },
                "Enchant Mr. Right"
              ),
              view.el(
                ["NavLink", 13],
                { to: "https://texting.tips" },
                "Texting Tips"
              )
            ),
            view.el(
              ["colu", 5],
              { className: "lastColu" },
              view.el(
                ["bigText", 4],
                { className: "heading" },
                "Coaching"
              ),
              view.el(
                ["NavLink", 14],
                { to: "/residential/men" },
                "Men's Residential Weekend"
              ),
              view.el(
                ["NavLink", 15],
                { to: "/residential/women" },
                "Women's Residential Weekend"
              )
            )
          )
        );
      });

      $["$"] = function (_, _index) {
        return {
          width: context.width.get() };
      };

      "e0b1dbac";
      "66113cbb";

      $["copyright"] = function (_, _index) {
        return { fontSize: context.isMobile.get() ? 10 : Math.max(8, 0.01 * context.width.get()) };
      };

      "0c72b710";
      "5e28afb8";
      "567e105e";
      "5d247234";
      "7cb3d25b";

      $["colu"] = function (_, _index) {
        return { marginRight: .05 * context.width.get()
        };
      };

      "c3de04f0";

      $["NavLink"] = function (_, _index) {
        return {
          fontSize: Math.max(12, .014 * context.width.get()), link: {
            whiteSpace: 'nowrap'
          }
        };
      };

      "3e73276e";

      $["bigText"] = function (_, _index) {
        return { fontSize: Math.max(12, .014 * context.width.get()) };
      };

      "8f96ce3a";
      "4c4a8b36";

      $["logoColu"] = function (_, _index) {
        return { marginRight: .07 * context.width.get()
        };
      };

      "514d5e58";

      $["logo"] = function (_, _index) {
        return {
          width: .15 * context.width.get() };
      };

      "c43b7c26";
    });
  })
})();
//# sourceMappingURL=footer.js.map
